import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import CrewDisplay from '../job/CrewDisplay';

export default class CrewDisplayButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = { showModal: false };
    }

    toggleModal = () => {
        const { showModal } = this.state;

        this.setState({ showModal: !showModal });
    };

    render() {
        const { longTermSchedule, crews } = this.props;
        const { showModal } = this.state;

        if (!longTermSchedule || !longTermSchedule.crewId) {
            return null;
        }

        const crew =
            longTermSchedule.publishedCrew ??
            crews.find((c) => c.id == longTermSchedule.crewId);

        return (
            <>
                <Button
                    className="mt-2"
                    type="button"
                    size="sm"
                    color="success"
                    outline
                    onClick={this.toggleModal}
                >
                    <FontAwesomeIcon
                        icon={faMagnifyingGlass}
                        className="mr-1"
                    />
                    Show crew details
                </Button>

                <Modal isOpen={showModal} toggle={this.toggleModal} size="xl">
                    <ModalHeader toggle={this.toggleModal}>
                        Crew Details - {crew.name}
                    </ModalHeader>
                    <ModalBody>
                        <CrewDisplay crew={crew} {...this.props} />
                    </ModalBody>
                </Modal>
            </>
        );
    }
}
